const style: any = {
    'fontFamily': 'Roboto',
    'fontStyle': 'normal',
    'fontWeight': '400',
    'fontSize': '14px',
    'lineHeight': '142%',
    'textAlign': 'center',
    'letterSpacing': '0.005em',
    'color': '#4D4D4D',
    'padding': '0px 6%',
    'marginBottom': '24px'
}

export default function HelpText() {

    return (
        <div style={style}>Para recuperar su contraseña, por favor ingrese el e-mail con el que se realizó su registro. Luego de enviar ingrese a la bandeja de entrada de su e-mail para establecer una nueva contraseña.</div>
    );

}